// 过滤格式，将格式生成成符合集联选择器的格式
export function generatePairs(options) {
  return options.map(item => [item])
}

// 还原入参格式
export function restoreOriginalObject(pairs) {
  return pairs.flat()
}

export function getOneLabel(options, seoValue) {
  const label = options.find(item => item.id === seoValue)
  return label?.label ?? undefined
}
